'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var ToggleableContext = require('../alloy-toggleable/ToggleableContext.js');
var ChevronUpIcon = require('../alloy-icon/ChevronUpIcon.js');
var ChevronDownIcon = require('../alloy-icon/ChevronDownIcon.js');

var AccordionItem = function (_a) {
    var children = _a.children, id = _a.id, title = _a.title, _b = _a.hideInactive, hideInactive = _b === void 0 ? false : _b;
    var ctx = react.useContext(ToggleableContext.default);
    var toggleActive = ctx.toggleActive;
    var isActive = ctx.isActive(id);
    var icon = isActive ? jsxRuntime.jsx(ChevronUpIcon.default, {}) : jsxRuntime.jsx(ChevronDownIcon.default, {});
    var handleClick = react.useCallback(function () {
        toggleActive(id);
    }, [id, toggleActive]);
    return (jsxRuntime.jsxs("div", tslib.__assign({ className: "d-flex flex-column" }, { children: [jsxRuntime.jsxs("div", tslib.__assign({ className: "d-flex justify-content-between flex-grow-1 align-items-start" }, { children: [title, jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ buttonType: "ghost", onClick: handleClick }, { children: icon }))] })), (isActive || hideInactive) && (jsxRuntime.jsx("div", tslib.__assign({ className: hideInactive && !isActive ? 'd-none' : '' }, { children: children })))] })));
};
var AccordionItem$1 = AccordionItem;

exports.default = AccordionItem$1;
//# sourceMappingURL=AccordionItem.js.map
